export class BaseFilter {
  keyword: string;

  static withKeyword(keyword: string): BaseFilter {
    return {
      keyword: keyword
    };
  }
}
